import { render, staticRenderFns } from "./des.vue?vue&type=template&id=0d9b6d8f&scoped=true&"
import script from "./des.vue?vue&type=script&lang=js&"
export * from "./des.vue?vue&type=script&lang=js&"
import style0 from "./des.vue?vue&type=style&index=0&id=0d9b6d8f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b6d8f",
  null
  
)

export default component.exports